import { useContext } from 'react';
import { CheckoutContext } from '../../../context/Checkout';
import { PurchaseCard } from '../../molecules';
import styles from './Bundles.module.scss';

export const BundlesMercadoPago = ({
  appButton,
  origin,
  paymentCards,
  isCreditCardMpActive,
  isPixMpActive,
  userState = '',
  isPagaLeveActive,
  userInfo,
  changePagarmeToPagaleve,
  newDesign,
  isIuguActive,
  isStarkBankActive,
  gamificationInfo,
  setGamificationData,
}) => {
  const {
    checkoutData: { bundlesData },
  } = useContext(CheckoutContext);

  return (
    <div className={`wrapper__bundles ${styles['wrapper__bundles']}`}>
      {bundlesData.map((bundle) => (
        <PurchaseCard
          key={bundle.id}
          id={bundle.id}
          nameId={bundle.nameId}
          title={bundle.title}
          totalCoins={bundle.totalCoins}
          totalPrice={bundle.totalPrice}
          installmentsLabel={bundle.installmentsLabel}
          installmentsDetails={bundle.installmentsDetails}
          appButton={appButton}
          origin={origin}
          paymentCards={paymentCards}
          isCreditCardMpActive={isCreditCardMpActive}
          isPixMpActive={isPixMpActive}
          userState={userState}
          isPagaLeveActive={isPagaLeveActive}
          userInfo={userInfo}
          changePagarmeToPagaleve={changePagarmeToPagaleve}
          newDesign={newDesign}
          isIuguActive={isIuguActive}
          isStarkBankActive={isStarkBankActive}
          gamificationInfo={gamificationInfo}
          setGamificationData={setGamificationData}
        />
      ))}
    </div>
  );
};
